<script lang="ts" setup>
  const userStore = useUserStore();

  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value);
  };
</script>

<template>
  <div class="wholesaler-alert">
    <span class="wholesaler-alert-content">
      Você está comprando com preços especiais para revenda e grandes volumes.
      <span v-if="userStore.wholesalerMinValue"
        >O seu mínimo de compra deve ser de
        {{ formatCurrency(userStore.wholesalerMinValue) }}</span
      >
    </span>
  </div>
</template>

<style lang="scss" scoped>
  .wholesaler-alert {
    @apply flex w-full mx-auto bg-brand-secondary-dark text-neutral-high-pure px-2xs py-micro leading-[1.15];
  }

  .wholesaler-alert-content {
    @apply max-w-[1440px] w-full mx-auto;
  }
</style>
